import {SearchFormValuesType} from "../../search/types/SearchFormValuesType";
import {stringifyConstructionEndDate} from "../../search/utils/stringify_construction_end_date";
import {stringifySearchFormArea} from "../../search/utils/stringify_search_form_area";
import {stringifySearchFormRooms} from "../../search/utils/stringify_search_form_rooms";
import {stringifySearchFormType} from "../../search/utils/stringify_search_form_type";
import {IHitFiltersInteractionParams} from "../types/IHitFiltersInteractionParams";

export function convertSearchFormToFiltersTracking(formValues: SearchFormValuesType): IHitFiltersInteractionParams {
    return {
        budgetType: !formValues.instalment ? "Kwota maksymalna" : "Rata kredytu",
        budget: !formValues.instalment ? formValues.price.upper : formValues.instalment,
        propertyType: stringifySearchFormType(formValues.type),
        rooms: stringifySearchFormRooms(formValues.rooms),
        area: stringifySearchFormArea(formValues.area),
        deliveryTime: stringifyConstructionEndDate(formValues.construction_end_date)
    };
}
import {SearchFormValuesType} from "../../search/types/SearchFormValuesType";
import {stringifyConstructionEndDate} from "../../search/utils/stringify_construction_end_date";
import {stringifySearchFormArea} from "../../search/utils/stringify_search_form_area";
import {stringifySearchFormRooms} from "../../search/utils/stringify_search_form_rooms";
import {stringifySearchFormType} from "../../search/utils/stringify_search_form_type";
import {IHitFiltersInteractionParams} from "../types/IHitFiltersInteractionParams";

export function convertSearchFormToFiltersTracking(formValues: SearchFormValuesType): IHitFiltersInteractionParams {
    return {
        budgetType: !formValues.instalment ? "Kwota maksymalna" : "Rata kredytu",
        budget: !formValues.instalment ? formValues.price.upper : formValues.instalment,
        propertyType: stringifySearchFormType(formValues.type),
        rooms: stringifySearchFormRooms(formValues.rooms),
        area: stringifySearchFormArea(formValues.area),
        deliveryTime: stringifyConstructionEndDate(formValues.construction_end_date)
    };
}
